<template>
  <bscroll-view>
    <div class="home-content">
      <div
        class="special-bg"
        v-if="specialBg != ''"
        :style="{ 'background-image': `url('${specialBg}')` }"
      />
      <div v-if="!bossMode" class="recommend-wrap">
        <div
          v-for="(item, index) in topRecommend"
          :key="index"
          class="hb-resource-cover recommend-item lr-img-scale lr-high-light lr-magazine-cover"
          @click="detailDispatcher('magazine', item, 1)"
        >
          <img :src="item.poster" />
        </div>
      </div>
      <div class="rank-wrap">
        <div class="rank-tab">
          <div
            v-for="(item,index) in rankTabs"
            :key="index"
            :class="{ 'rank-tab-checked': tabsIndex === index }"
            class="rank-tab-item"
            @click="tabclick(index)"
          >
            <!-- @click="checkedRankTab = tab.val" -->
            {{ langTransfer(item.text) }}
          </div>
        </div>
        <div class="rank-content">
          <div class="top-one" @click="detailDispatcher('magazine', firstRank, 1)">
            <div
              class="hb-resource-cover cover lr-img-scale lr-high-light lr-magazine-cover"
            >
              <img :src="firstRank.poster" />
            </div>
            <div class="infos">
              <p class="tag-text">#今日推荐#</p>
              <p class="name text1line">
                <span>01</span>{{ langTransfer(firstRank.name) }}
              </p>
              <p class="summary text2line">
                {{ langTransfer(firstRank.note) }}
              </p>
              <p v-if="firstRank.year && firstRank.issue" class="year-issue">
                {{ langTransfer("更新至：") }}
                {{
                  langTransfer(
                    `${firstRank.year}年${("0" + firstRank.issue).substr(-2)}期`
                  )
                }}
              </p>
              <button
                class="start-read lr-img-scale"
                @click="detailDispatcher('magazine', firstRank, 1)"
              >
                开始阅读
              </button>
            </div>
          </div>
          <div class="list">
            <div
              v-for="(item, index) in newRankList.slice(1)"
              :key="index"
              class="item"
              @click="detailDispatcher('magazine', item, 1)"
            >
              <div
                class="hb-resource-cover cover lr-img-scale lr-high-light lr-magazine-cover"
              >
                <img :src="item.poster" />
              </div>
              <p class="index">
                {{ `0${index + 2}`.substr(-2) }}
              </p>
              <div class="infos">
                <p class="name text1line">
                  {{ langTransfer(item.name) }}
                </p>
                <p v-if="item.year && item.issue" class="year-issue">
                  {{
                    langTransfer(
                      `${item.year}年${("0" + item.issue).substr(-2)}期`
                    )
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-for="typeData in typeAnchors"
        :key="typeData.val"
        class="section-wrap"
      >
        <section
          v-if="typeData.type === 1"
          :ref="`resourceSection${typeData.type}`"
          class="common-resource-section"
        >
          <h5 class="common-type-title">
            {{ langTransfer(typeData.name) }}
          </h5>
          <div class="resource-list">
            <div
              v-for="(item, index) in typeData.list.slice(5)"
              :key="index"
              class="magazine-item"
              @click="detailDispatcher('magazine', item, 1)"
            >
              <div
                class="hb-resource-cover cover lr-img-scale lr-high-light lr-magazine-cover"
              >
                <img :src="item.poster" />
              </div>
              <p class="name text1line">
                {{ langTransfer(item.name) }}
              </p>
              <p class="year-issue">
                {{
                  langTransfer(
                    `${item.year}年${("0" + item.issue).substr(-2)}期`
                  )
                }}
              </p>
            </div>
          </div>
          <button
            class="common-read-more lr-img-scale"
            @click="goList(typeData.type)"
          >
            {{ langTransfer("查看更多") }}
          </button>
          <div v-if="bossMode && currentRankList.length > 0" class="rank-wrap">
            <div class="rank-tab">
              <div
                v-for="tab in rankTabs"
                :key="tab.val"
                :class="{ 'rank-tab-checked': checkedRankTab === tab.val }"
                class="rank-tab-item"
                @click="checkedRankTab = tab.val"
              >
                {{ langTransfer(tab.text) }}
              </div>
            </div>
            <div class="rank-content">
              <div
                class="top-one"
                @click="detailDispatcher('magazine', item, 1)"
              >
                <div
                  class="hb-resource-cover cover lr-img-scale lr-high-light lr-magazine-cover"
                >
                  <img :src="topOne.poster" />
                </div>
                <div class="infos">
                  <p class="tag-text">#今日推荐#</p>
                  <p class="name text1line">
                    <span>01</span>{{ langTransfer(topOne.name) }}
                  </p>
                  <p class="summary text2line">
                    {{ langTransfer(topOne.introduction) }}
                  </p>
                  <p v-if="topOne.year && topOne.issue" class="year-issue">
                    {{ langTransfer("更新至：") }}
                    {{
                      langTransfer(
                        `${topOne.year}年${("0" + topOne.issue).substr(-2)}期`
                      )
                    }}
                  </p>
                  <button
                    class="start-read lr-img-scale"
                    @click="detailDispatcher('magazine', topOne, 1)"
                  >
                    开始阅读
                  </button>
                </div>
              </div>
              <div class="list">
                <div
                  v-for="(item, index) in currentRankList.slice(1)"
                  :key="index"
                  class="item"
                  @click="detailDispatcher('magazine', item, 1)"
                >
                  <div
                    class="hb-resource-cover cover lr-img-scale lr-high-light lr-magazine-cover"
                  >
                    <img :src="item.poster" />
                  </div>
                  <p class="index">
                    {{ `0${index + 2}`.substr(-2) }}
                  </p>
                  <div class="infos">
                    <p class="name text1line">
                      {{ langTransfer(item.name) }}
                    </p>
                    <p v-if="item.year && item.issue" class="year-issue">
                      {{
                        langTransfer(
                          `${item.year}年${("0" + item.issue).substr(-2)}期`
                        )
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          v-if="typeData.type === 15"
          :ref="`resourceSection${typeData.type}`"
          class="common-resource-section"
        >
          <h5 class="common-type-title">
            {{ langTransfer(typeData.name) }}
          </h5>
          <div class="resource-list book-list">
            <div
              v-for="(item, index) in typeData.list"
              :key="index"
              class="book-item"
              @click="detailDispatcher('assemblyBook', item)"
            >
              <div
                class="hb-resource-cover knowledge-item-cover lr-img-scale lr-high-light lr-book-cover"
              >
                <img :src="item.poster" />
              </div>
              <p class="name text1line">
                {{ langTransfer(item.name) }}
              </p>
            </div>
            <img
              class="more-icon"
              src="@/assets/img/more.png"
              @click="goList(typeData.type)"
            />
          </div>
        </section>
        <section
          v-if="typeData.type === 3"
          :ref="`resourceSection${typeData.type}`"
          class="common-resource-section"
        >
          <h5 class="common-type-title">
            {{ langTransfer(typeData.name) }}
          </h5>
          <div class="resource-list book-list">
            <div
              v-for="(item, index) in typeData.list"
              :key="index"
              class="book-item"
              @click="detailDispatcher('book', item)"
            >
              <div
                class="hb-resource-cover knowledge-item-cover lr-img-scale lr-high-light lr-book-cover"
              >
                <img :src="item.poster" />
              </div>
              <p class="name text1line">
                {{ langTransfer(item.name) }}
              </p>
            </div>
            <img
              class="more-icon"
              src="@/assets/img/more.png"
              @click="goList(typeData.type)"
            />
          </div>
        </section>
        <section
          v-if="typeData.type === 5"
          :ref="`resourceSection${typeData.type}`"
          class="common-resource-section"
        >
          <h5 class="common-type-title">
            {{ langTransfer(typeData.name) }}
          </h5>
          <div class="resource-list video-list">
            <div
              v-for="(item, index) in typeData.list"
              :key="index"
              class="video-item"
              @click="detailDispatcher('video', item)"
            >
              <div class="hb-resource-cover cover lr-img-scale">
                <img :src="item.poster" />
                <img class="play-icon" src="@/assets/img/play.png" />
              </div>
              <p class="name text1line">
                {{ langTransfer(item.name) }}
              </p>
            </div>
            <img
              class="more-icon"
              src="@/assets/img/more.png"
              @click="goList(typeData.type)"
            />
          </div>
        </section>
        <section
          v-if="typeData.type === 4"
          :ref="`resourceSection${typeData.type}`"
          class="common-resource-section"
        >
          <h5 class="common-type-title">
            {{ langTransfer(typeData.name) }}
          </h5>
          <div class="resource-list sound-book-list">
            <div
              v-for="(item, index) in typeData.list"
              :key="index"
              class="sound-book-item"
              @click="detailDispatcher('audio', item)"
            >
              <div class="hb-resource-cover cover lr-img-scale">
                <img :src="item.poster" />
                <img class="play-icon" src="@/assets/img/play.png" />
              </div>
              <p class="name text2line">
                {{ langTransfer(item.name) }}
              </p>
            </div>
            <img
              class="more-icon"
              src="@/assets/img/more.png"
              @click="goList(typeData.type)"
            />
          </div>
        </section>
      </div>
    </div>
    <footer-com />
  </bscroll-view>
</template>

<script>
import FooterCom from "@/components/footerCom/footerCom";
import BscrollView from "@/components/bscrollView";
import { recommendList, strongRecommendList } from "../../api/lyl";

// const mainBgDefault = require('@/assets/img/special-bg.jpg')
const mainBgDefault = "";

export default {
  name: "Home",
  components: {
    FooterCom,
    BscrollView,
  },
  data() {
    return {
      firstRank:{},
      checkedRankTab: "everydaylist",
      newRankList: [],
      tabsIndex:0,
      rankTabs: [
        {
          text: "每日推荐",
          value:1
        },
        {
          text: "每周推荐",
          value:2
        },
        {
          text: "每月推荐",
          value:3
        },
      ],
      // rankTabs: [
      //   {
      //     text: "每日推荐",
      //     val: "everydaylist",
      //     list: [],
      //   },
      //   {
      //     text: "周排行",
      //     val: "everyweeklist",
      //     list: [],
      //   },
      //   {
      //     text: "月排行",
      //     val: "everymonthlist",
      //     list: [],
      //   },
      // ],
      typeAnchors: [],
      topRecommend: [],
      bossMode: false,
    };
  },
  computed: {
    upperPart() {
      return this.$store.state.upperPart;
    },
    webInfo() {
      return this.$store.state.webInfo;
    },
    currentRankList() {
      const { checkedRankTab, rankTabs } = this;
      const result = rankTabs.find((e) => {
        return e.val === checkedRankTab;
      });
      return result ? result.list : [];
    },
    topOne() {
      const { currentRankList } = this;
      return currentRankList[0] || {};
    },
    specialBg() {
      const { upperPart } = this.$store.state;
      console.log(upperPart)
      if (!upperPart.enableModuleList) {
        return mainBgDefault;
      }

      const result = upperPart.enableModuleList.find((e) => {
        return e.type === 4;
      });

      return result && result.poster ? result.poster : "";
    },
  },
  watch: {
    webInfo(newVal) {
      if (newVal.service_code) {
        const { id } = this.$route.params;
        this.recommendList(id);
        this.strongRecommendList(id);
      }
    },
    // currentRankList(newVal){
    //   console.log(newVal)
    // }
  },
  methods: {
    tabclick(e){
      this.tabsIndex = e
      this.strongRecommendList()
    },
    strongRecommendList() {
      strongRecommendList({
        service_code: this.webInfo.service_code,
        unique_code:this.$route.params.id,
        section:this.tabsIndex+1,
        top: 10,
      }).then((res) => {
        this.firstRank = res[0]
        this.newRankList = res;
      });
    },
    goList(type) {
      const { id } = this.$route.params;
      const { href } = this.$router.resolve({
        name: "specialList",
        params: {
          id,
          type,
        },
      });
      window.open(href, "_blank");
    },
    async recommendList(unique_code) {
      try {
        const data = await recommendList({
          service_code: this.webInfo.service_code,
          unique_code,
          type: 1,
        });
        this.typeAnchors = data;
        this.initRankTab(data);
        this.initTopRecommend(data);
      } catch (err) {
        console.log(err);
      }
    },
    initRankTab(data) {
      const result = data.find((e) => {
        return e.type === 1;
      });
      this.rankTabs.forEach((e) => {
        e.list = result[e.val];
      });
    },
    initTopRecommend(data) {
      const result = data.find((e) => {
        return e.type === 1;
      });
      this.topRecommend =
        result && result.list.length > 0 ? result.list.slice(0, 6) : [];
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const { service_code } = vm.webInfo;
      if (service_code) {
        const { id } = to.params;
        vm.recommendList(id);
        vm.strongRecommendList(id);
      }
    });
  },
};
</script>

<style scoped lang="less">
@media screen and (max-width: 10000px) {
  .home-content {
    width: 1296px;
  }
  .item {
    width: 240px;
  }
  .recommend-item {
    width: 190px;
  }
  .top-one {
    width: 504px;
    cursor: pointer;
  }
  .name {
    width: 298px;
  }
  .summary {
    width: 298px;
  }
  .year-issue {
    width: 199px;
  }
}
@media screen and (max-width: 1280px) {
  .home-content {
    width: 1136px;
  }
  .recommend-item {
    width: 170px;
  }
  .item {
    width: 190px;
  }
  .top-one {
    width: 444px;
  }
  .name {
    width: 234px;
  }
  .summary {
    width: 234px;
  }
  .year-issue {
    width: 135px;
  }
}
.home-content {
  min-height: calc(100vh - 80px - 50px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.special-bg {
  width: 100%;
  height: 360px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.recommend-wrap {
  width: 100%;
  margin-top: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .recommend-item {
    border-radius: 4px;
  }
}

.rank-wrap {
  width: 100%;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.rank-tab {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .rank-tab-item {
    padding: 5px 10px;
    height: 24px;
    font-size: 15px;
    font-family: AlibabaPuHuiTiM;
    color: #909399;
    line-height: 24px;
    // font-weight: 600;
    cursor: pointer;
    margin-right: 30px;
    transition: 0.3s;

    &:last-child {
      margin-right: 0;
    }
  }

  .rank-tab-checked {
    color: #303133;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
  }
}

.rank-content {
  width: 100%;
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .top-one {
    height: 100%;
    box-sizing: border-box;
    padding: 20px;
    background: #f5f7fa;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;

    .cover {
      width: 150px;
      height: 200px;
      border-radius: 4px;
    }

    .infos {
      margin-left: 16px;
      flex: 1;
      height: 200px;
      box-sizing: border-box;
      padding: 18px 0;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      position: relative;

      .tag-text {
        width: 100%;
        font-size: 15px;
        font-family: AlibabaPuHuiTiM;
        color: #606266;
        line-height: 24px;
        // font-weight: 600;
      }

      .name {
        font-size: 24px;
        font-family: AlibabaPuHuiTiB;
        color: #606266;
        line-height: 24px;
        margin: 10px 0;
        // font-weight: 600;

        span {
          margin-right: 16px;
        }
      }

      .summary {
        height: 40px;
        font-size: 13px;
        font-family: AlibabaPuHuiTiR;
        color: #909399;
        line-height: 20px;
        margin-bottom: 28px;
        // font-weight: 600;
      }

      .year-issue {
        font-size: 13px;
        font-family: AlibabaPuHuiTiM;
        color: #909399;
        line-height: 20px;
        // font-weight: 600;
      }

      .start-read {
        height: 36px;
        padding: 0 10px;
        font-size: 12px;
        font-family: AlibabaPuHuiTiM;
        color: #ffffff;
        background: #303133;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        position: absolute;
        right: 0;
        bottom: 18px;
        // font-weight: 600;
      }
    }
  }

  .list {
    margin-left: 24px;
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    .item {
      height: 80px;
      box-sizing: border-box;
      padding: 10px 20px;
      border-bottom: 1px #e6e6e6 solid;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      cursor: pointer;
    }

    .cover {
      width: 45px;
      height: 60px;
      border-radius: 2px;
    }

    .index {
      width: 20px;
      height: 24px;
      margin: 10px;
      font-size: 15px;
      font-family: AlibabaPuHuiTiM;
      color: #606266;
      line-height: 24px;
      // font-weight: 600;
    }

    .infos {
      flex: 1;
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;

      .name {
        width: 115px;
        font-size: 15px;
        font-family: AlibabaPuHuiTiM;
        color: #606266;
        line-height: 24px;
        // font-weight: 600;
      }

      .year-issue {
        width: 100%;
        margin-top: 4px;
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #909399;
        line-height: 12px;
        // font-weight: 600;
      }
    }
  }
}

.section-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
</style>
